import {Component, ElementRef, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Route, RouteLoader} from 'shared';
import {Observable, Subscription} from 'rxjs';
import DataSource from 'devextreme/data/data_source';
import ArrayStore from 'devextreme/data/array_store';
import {DxChartComponent} from 'devextreme-angular';

@Component({
  selector: 'app-tractors-history-fuel',
  templateUrl: './tractors-history-fuel.component.html',
  styleUrls: ['./tractors-history-fuel.component.scss']
})
export class TractorsHistoryFuelComponent implements OnInit, OnDestroy {

  @Input()
  loader: RouteLoader;
  private loaderSub: Subscription;

  route: Route;
  ds: DataSource;
  store: ArrayStore;
  fillingDs: DataSource;
  fillingStore: ArrayStore;

  @ViewChild(DxChartComponent, {static: true})
  chartComponent: DxChartComponent;

  @Input()
  onResize: Observable<number[]>;
  private onResizeSub: Subscription;
  width = 450;
  height: number;

  isLoading: boolean;

  constructor(public host: ElementRef) {
    this.store = new ArrayStore({
      data: [],
    });
    this.ds = new DataSource({
      paginate: false,
      store: this.store,
    });
    this.fillingStore = new ArrayStore({
      data: [],
    });
    this.fillingDs = new DataSource({
      paginate: false,
      store: this.fillingStore,
    });

    // Bindings
    this.resetChart = this.resetChart.bind(this);
    this.valueAxisAddUnit = this.valueAxisAddUnit.bind(this);
  }

  ngOnInit(): void {
    this.loaderSub = this.loader.loading$.subscribe(isLoading => {
      this.isLoading = isLoading;
      if (!isLoading) {
        this.route = this.loader.route;
      }
      if (isLoading) {
        this.clean();
      } else {
        this.build();
      }
    });

    this.onResizeSub = this.onResize.subscribe((size) => {
      this.width = size[0] - 20;
      this.height = size[1];
      // this.chartComponent.instance.refresh();
    });
  }

  private clean() {
    this.store.clear();
    this.fillingStore.clear();
  }

  private build() {
    if (!this.loader.route.fuel_consumption) {
      return;
    }

    this.loader.route.fuel_consumption.levels.forEach(d => {
      this.store.insert(d);
    });
    this.ds.reload();

    this.loader.route.fuel_consumption.fillings().forEach(d => {
      this.fillingStore.insert(d);
    });
    this.fillingDs.reload();
  }

  resetChart() {
    this.chartComponent.instance.resetVisualRange();
  }

  ngOnDestroy(): void {
    this.loaderSub.unsubscribe();
    this.onResizeSub.unsubscribe();
  }

  valueAxisAddUnit(label) {
    return label.valueText + ' L';
  }
}
